(function () {
  'use strict';

  // ── Scroll fade ──────────────────────────────────────────
  var header = document.getElementById('jh-header');
  if (header) {
    var lastY = window.scrollY;
    var ticking = false;

    function handleScroll() {
      var y = window.scrollY;
      if (y <= 10) {
        header.classList.remove('is-hidden');
      } else if (y > lastY) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(handleScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  // ── Mobile overlay ───────────────────────────────────────
  var burger    = document.getElementById('jh-burger');
  var mobileNav = document.getElementById('jh-mobile-nav');
  var closeBtn  = document.getElementById('jh-mobile-close');
  var colToggle = document.getElementById('jh-col-toggle');
  var colSub    = document.getElementById('jh-col-sub');

  function openNav() {
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (burger)    burger.addEventListener('click', openNav);
  if (closeBtn)  closeBtn.addEventListener('click', closeNav);

  if (colToggle && colSub) {
    colToggle.addEventListener('click', function () {
      var isOpen = colSub.classList.toggle('is-open');
      colToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  document.querySelectorAll('.jh-mobile-nav__group [data-toggle]').forEach(function (toggle) {
    var sub = toggle.parentElement.querySelector('[data-sub]');
    if (!sub) return;
    toggle.addEventListener('click', function () {
      sub.classList.toggle('is-open');
    });
  });

  // Escキーで閉じる
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  // ── Language / region switcher ───────────────────────────
  function submitLocalization(form, locale, country) {
    var localeInput  = form.querySelector('.jh-loc__locale-input');
    var countryInput = form.querySelector('.jh-loc__country-input');
    if (localeInput)  localeInput.value  = locale;
    if (countryInput) countryInput.value = country;
    form.submit();
  }

  // ── Currency/language consistency guard ──────────────────
  // 言語ごとに通貨(国)が1対1で固定の設計のため、Cookieの通貨設定が
  // 現在表示中の言語と食い違っている場合（例: 中国語版で人民元に
  // 切り替えた後、切り替えボタンを使わずに日本語ページへ戻った場合など）、
  // 表示中の言語に対応する国・通貨へ自動的に補正する。
  (function () {
    var loc = window.__jhLocale;
    if (!loc) return;
    var expectedCountry = { en: 'US', ja: 'JP', 'zh-CN': 'CN', ko: 'KR' };
    var expected = expectedCountry[loc.language];
    if (!expected || loc.country === expected) return;

    var form = document.querySelector('.jh-loc');
    if (!form) return;
    submitLocalization(form, loc.language, expected);
  })();

  document.querySelectorAll('.jh-loc').forEach(function (form) {
    var trigger = form.querySelector('.jh-loc__trigger');
    var panel   = form.querySelector('.jh-loc__panel');

    if (trigger && panel) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !panel.hidden;
        panel.hidden = isOpen;
        trigger.setAttribute('aria-expanded', String(!isOpen));
      });

      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) {
          panel.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          panel.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    form.querySelectorAll('.jh-loc__option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        submitLocalization(form, btn.dataset.locale, btn.dataset.country);
      });
    });
  });
})();
